import React from 'react';
import { FaInfoCircle, FaMousePointer, FaPlay, FaTh } from 'react-icons/fa';

interface MultiviewHelpProps {
  isSelectionMode: boolean;
  selectedCount: number;
  maxStreams: number;
}

const MultiviewHelp: React.FC<MultiviewHelpProps> = ({
  isSelectionMode,
  selectedCount,
  maxStreams
}) => {
  if (!isSelectionMode && selectedCount === 0) return null;

  return (
    <div className="multiview-help-section">
      <div className="help-icon">
        <FaInfoCircle />
      </div>
      
      <div className="help-content">
        {isSelectionMode ? (
          <div className="help-steps">
            <div className="help-step">
              <FaMousePointer />
              <span>Étape 1: Cliquez sur les <strong>+</strong> des streams pour les sélectionner</span>
            </div>
            <div className="help-step">
              <FaPlay />
              <span>Étape 2: Cliquez sur <strong>"Ouvrir Multiview"</strong> pour lancer</span>
            </div>
            <div className="help-progress">
              {selectedCount}/{maxStreams} streams sélectionnés
            </div>
          </div>
        ) : (
          <div className="help-selected">
            <FaTh />
            <span>{selectedCount} stream{selectedCount > 1 ? 's' : ''} prêt{selectedCount > 1 ? 's' : ''} pour le multiview</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MultiviewHelp;